import {
  MarketplaceForm,
  MarketplaceFormElement,
  MarketplaceFormElementType,
  MarketplaceFormElementValidation,
  MarketplaceFormElementWidget,
} from "../../../schema/generated/schema";
import { createGenericForm } from "../../FormEditor/util";

const OVERVIEW_FORM_ELEMENTS: Partial<MarketplaceFormElement>[] = [
  {
    key: "subject",
    type: MarketplaceFormElementType.Text,
    label: "Project Title",
    required: true,
  },
  {
    key: "description",
    type: MarketplaceFormElementType.Text,
    widget: MarketplaceFormElementWidget.Textarea,
    label: "Description",
    description:
      "Include any specific details, requirements, and quantities for this project.",
    required: true,
  },
  {
    key: "dateNeededBy",
    type: MarketplaceFormElementType.Date,
    widget: MarketplaceFormElementWidget.DatePicker,
    label: "Date Needed By",
    required: true,
  },
];

const ANON_OPPORTUNITY_FORM_ELEMENTS: Partial<MarketplaceFormElement>[] = [
  {
    key: "email",
    type: MarketplaceFormElementType.Text,
    label: "Email",
    required: true,
    validation: MarketplaceFormElementValidation.Email,
  },
  {
    key: "subject",
    type: MarketplaceFormElementType.Text,
    label: "Subject",
    required: true,
  },
  {
    key: "description",
    type: MarketplaceFormElementType.Text,
    widget: MarketplaceFormElementWidget.Textarea,
    label: "Description",
    description:
      "Include any specific details, requirements, and quantities for this project.",
    required: true,
  },
];

export const getOverviewForm = (isSeller?: boolean): MarketplaceForm => {
  const form: MarketplaceForm = createGenericForm({
    name: "Overview",
    partialElements: !isSeller
      ? OVERVIEW_FORM_ELEMENTS
      : [
          ...OVERVIEW_FORM_ELEMENTS,
          {
            key: "buyerEmail",
            type: MarketplaceFormElementType.Text,
            label: "Recipient Email",
            required: true,
            validation: MarketplaceFormElementValidation.Email,
          },
        ],
  });
  return {
    ...form,
    versionId: "overview-form",
  };
};

export const getAnonOpportunityForm = (): MarketplaceForm => {
  const form: MarketplaceForm = createGenericForm({
    name: "Opportunity",
    partialElements: ANON_OPPORTUNITY_FORM_ELEMENTS,
  });
  return {
    ...form,
    versionId: "anon-opportunity-form",
  };
};

export const getBuyerEmail = marketplaceObj => {
  if (marketplaceObj.buyer || marketplaceObj.unregisteredBuyerEmail) {
    return (
      marketplaceObj.buyer?.emailAddress ||
      marketplaceObj.unregisteredBuyerEmail
    );
  }
  return "";
};

export const CONSULTATION_FORM_ID = "6a61abba-031b-4259-a1d6-3f31fcbf3c66"; // Form id from Retool.
